// src/components/ProtectedRoute.js
import React from 'react';
//                  👇👇👇 Importar Outlet y useLocation 👇👇👇
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// Ya no necesita recibir 'children' como prop cuando se usa como layout
const ProtectedRoute = () => {
  const token = localStorage.getItem('access_token'); // Usar clave correcta
  const location = useLocation();

  if (!token) {
    // Redirigir a Landing si no hay token
    console.log('ProtectedRoute: No token found, redirecting to /');
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si hay token, renderizar el Outlet.
  // React Router reemplazará el Outlet con el componente de la ruta hija (DesignStudio, Settings)
  console.log('ProtectedRoute: Token found, rendering Outlet.');
  return <Outlet />; // <<<--- RENDERIZAR OUTLET
};

export default ProtectedRoute;